module.exports = __webpack_public_path__ + "static/media/image_3_1.f6db58a1.svg";